// Curated line history for GODSC.
// Member rosters included where available. Editions shown newest -> oldest.

export const EDITIONS = [
  {
    edition: "40th",
    name: "19 Phantoms of a Severed Succession AKA Keepers of a Horror\u2019s Legacy Forged Where Wardens Once Stood RKA Last-Born Descendants of a Gentleman\u2019s Embrace",
    members: [
      "Talon Benton", "Vance Tyree", "Russell Ramirez",
      "Marvin Thomas", "Ayeme Owona", "Jaylen \u201cDropp\u201d Jones",
      "Nasir Heyward", "LeRone Adrian Clarke", "Brock Montgomery",
      "Makani Msangi", "Mark Baker", "Harmon Cummings",
      "Nathan Beneyam", "Bryce Barber", "Tony Parks",
      "Perry Jeffries Jr.", "Jakobe Brownlee", "Graham Lathan",
      "Perry Rainey",
    ],
  },
  {
    edition: "39th",
    name: "Outlaws of a Fulfilled Dynasty AKA Survivors of the Golden Plague RKA Barbarians of a New Crucible",
    members: [
      "Tavis White", "Adam Tolliver", "Joseph Clayton", "Bryce Sharpe",
      "Mikkahel Toussaint", "Malcolm Weekes", "Ezekiel Wesonga",
      "Silas Murangiri", "Rickelon Williams", "Izayah Hill",
      "Kanaan Celestine", "Trey Lynch III", "Bryce Williams",
      "Treyvon Graham", "Austin King", "Ahmed Shamte", "Jalon Sims",
      "Grace B. Kalere", "Emmanuel Reese", "Otis Lofton III",
      "Chris Shorter Jr.", "Terrence Reese Jr.", "Jeremy Noel",
    ],
  },
  {
    edition: "38th",
    name: "Wardens of an Eminent Inheritance AKA Last-born Descendants of a Revolutionary Acquisition RKA Preserves of Terror Survived by a Harmonic Tether",
    members: [
      "Jeremiah Ramirez", "Tayion Anderson", "Mark Marotta",
      "Joshua Smothers", "Yaw Poku", "Baxter Barber",
      "Ethan \u201cYusuf\u201d Walters", "Evan Garrick", "Michael Pearson",
      "Ma\u2019el Blunt", "Malachi Macmillan", "Jeremiah Michaels",
      "William McIntyre", "Lawson Bush", "Jakeem Israel",
      "Kai Avilez", "Joel Casey", "Michael Cobbins",
    ],
  },
  {
    edition: "37th",
    name: "Insurgents of a Gentlemen\u2019s Rebirth AKA Descendants of an Eternal Horror",
    members: [
      "Javier \u201cLion\u201d Benton", "Bryce Perkins", "Ali Kantao",
      "Troy Steagall Jr.", "Ezra Hudson", "Noah Fitzgerald",
      "Ahmod Newton", "Marquis Donegan", "Joseph Serra",
      "Michael Adeniyi", "Aaron Dubose", "Tony Asiema",
      "Pharez Rodgers", "Emmanuel Akinde", "Jared Baker",
      "Breland Reed Jr.", "Brice Facey", "Luis Roaches", "Charles Okoye",
    ],
  },
  {
    edition: "36th",
    name: "7 Horrors of the Merciless Kingdom AKA Watchmen of a Nightly Terror RKA Witnesses to the Reborn Rebellion",
    members: [
      "Jahmere Hargraves", "Miles Hunt", "Frederick Hamilton",
      "Elijah Cole Walton", "Julian Winbush", "Reginald Alexander",
      "Mory Diakite",
    ],
  },
  {
    edition: "35th",
    name: "16 Rebels of a Sublime Anarchy AKA Survivors of a Warrior\u2019s Wrath",
    members: [
      "Cameron Hodges", "Cameron Lewis", "Alex Jones", "Hunter Bean",
      "Rashawn Culzac", "Dylan Salters", "Charles Mainor Jr.",
      "Kingsley Ohanaja", "Dean Parham", "Nasir Smith", "Grant Hurt",
      "Jaquan Success", "Jordan Mcday", "Miles Thomas",
      "Temiloluwa Adanlawo", "Jasiri Evans",
    ],
  },
  {
    edition: "34th",
    name: "Prophets of a Gentlemen\u2019s Order AKA Guardians of a Merciless Kingdom RKA Successors to the Silver Legacy",
    members: [
      "Jahzhseed Hancock", "Anthony Williams-Birden", "Khara KT Mobley",
      "Bryan BG Garrett", "Wallace Washington", "Joshua Bell-Bey",
      "Marvin Pierre", "Isaiah Paysinger", "Simeon Wright",
      "Ahmen Lessanu", "Demarko Hooper", "Johnathon Releford",
      "Steven Short", "Juleian Cappel", "Nile Ellis", "Eric Harper",
      "Jimmel Ebanks", "Boykin Riviere", "Caleb Edmond",
      "Robert Wesley Dickerson Jr.", "Bach Clifton", "John Carpenter III",
      "Nigel Russell", "Samuel McTier", "Kameron Martin",
    ],
  },
  {
    edition: "33rd",
    name: "21 Warriors of a Refined Dynasty AKA Monarchs of an Infinite Glory",
    members: [
      "Dymier Steele", "Niko McMullen", "Daniel Owoyele",
      "Kelechukwu Emeruwa", "Elijah Catalan", "Phillip Brooks Jr.",
      "Nobel Gebru", "Myles Youngblood", "Theodros Alemu",
      "Marley Briscoe", "Roland Ridgeway IV", "Abdullah Jeffers",
      "Oumar Sow", "Delon Dixon", "Wayne Williams",
      "Jamison Monroe", "Zachary Shaiyen", "Ari Brathwaite",
      "Raines Warren", "Jordan Uwhubetine", "Juquan Wilson",
    ],
  },
  {
    edition: "32nd",
    name: "22 Lords of Eternal Obstinance AKA Tycoons of a Supreme Erudition RKA Descendants of the Silver Throne",
    members: [
      "Kennon Whitaker", "Greg Holmes", "Dexter Monk Jr.",
      "Julian Reeves", "Ambe Sennon", "Malik Kirkwood",
      "Nathan Jones", "Shaquille Shelby", "Nana Kofi-Preko",
      "JaMarr Sanders", "Jordan Murray", "Cameron Boone",
      "Zachary Cambridge Hanes", "Quentin Brown Harris",
      "Khristian Ifill", "Quentin Freeman", "Young Ho Jung",
      "Xavier Handy Hamilton", "Brandon Alexander", "Javen Cannon",
      "Malik Robinson", "Malcom Merritt",
    ],
  },
  {
    edition: "31st",
    name: "20 Gladiators of a Restoric Kingdom AKA Immortals of an Everlasting Apocalypse",
    members: [
      "Kendall Mason", "Arin Holliman", "Emmanuel Beach",
      "Malik Savage", "Joshua Otey", "Zoobier Vernon",
      "Ryan Mackenzi", "Pravion Winding", "Zachary Johnson",
      "Noah Nelson", "Jarett Powell", "Jared Jackson",
      "Grant Grundy", "Richard Ryles", "Noah Perkins",
      "Anthony Brandon Jr.", "Malachi Doughjar", "James Ward",
      "Reginald Irving Jr.", "Courtney Beezer",
    ],
  },
  {
    edition: "30th",
    name: "The 26 Sentinels of Tumescent Anarchy AKA Equivocators of Execution RKA Bearers of the Silver Torch",
    members: [
      "Rahsaan Everette", "Blake Van Putten", "Marcus Livingston",
      "Desmond Taylor", "Yusuf Hood", "Major Odem", "William Clayton III",
      "Justin Kennedy", "Macio Harrel", "Derek Fitzgerald",
      "William Foster", "Vernon Yancy", "Jameer Wilson",
      "Adrian Reed", "Earl Moore", "Rodney Due", "Julius Johnson",
      "Kyle Nichols", "Gary Guster", "Devin Citizen", "James Chavis",
      "Ronald Wilson", "Devin Merrit", "Kirk Ward",
      "Walter Jefferson", "Andrew Boyd",
    ],
  },
  {
    edition: "28th",
    name: "23 Templars of the Reign of Terror AKA Sinisters of Self-Destruction RKA Heirs to the Silver Dynasty",
    members: [
      "Kelvin Hicks", "Tsar Powell", "Sidiki Kane",
      "Thomas Burrell Jr.", "Jordan Hickman", "Leroy Peeples",
      "Paul Gasper", "Kyle Douglas", "Doug Brooks",
      "Raleigh Fatoki", "Jabari Thomas", "Jimmie Drummond III",
      "Herbert Humphrey Jr.", "Marcus Carey",
      "Royal \u201cNeeko\u201d Chase Farley", "Andrew Hairston",
      "Patrick Oseni", "Madiagne Sarr", "Shenick Alcine",
      "Jordan Taylor", "Jeremy Macklin", "Paul Hebert",
      "Kenneth Boyd Jr.",
    ],
  },
  {
    edition: "27th",
    name: "The 22 Disciples of a New Dawn",
    members: [
      "Zakir Lee Jones", "Maurice Dukes", "Justin Thomas",
      "Andre Foster", "Darren Jones", "Darryl Banks",
      "Hansford Scott Thomas", "Christian Thomas", "Nathaniel Alabi",
      "John Mark Williams", "Brandon Copeland", "Anthony Miles Jr.",
      "Chaun Tucker", "Duclas Charles", "Michael Sesay",
      "Brandon Harris", "Odunjo Copeland", "Phillip Armstrong",
      "Brandon Evans", "Robert Huckabee", "Willie Mayes",
      "Garrett White",
    ],
  },
  {
    edition: "26th",
    name: "Titans Out of the Depths of Hades AKA The Awakening",
    members: [
      "Joseph Barnes", "Devon Mayors", "Maliki Sirliep",
      "Deontay Morris", "Bacari Ahmed Ibrahim", "DeAngelo Shears",
      "Brantley Doctor", "Searcy Williams", "Jeremy Williams",
      "Justin Askew", "Samir Ahmed", "Kyle Weldon",
      "Steven Garrett", "Jonathan White", "Jai Winston",
      "Iran Set Heavey", "Nicolas Sneed", "Christopher Ard",
      "Domenio Smith", "Mark Sesay", "Ehren Vance",
      "Christopher Bryant", "Alex Smith", "Jesse \u201cZola\u201d Henry",
      "Ahmed Brown", "Steven Thompson",
    ],
  },
  {
    edition: "25th",
    name: "Ten Guardians of Ma\u2019at AKA Survivors of Infinite Defeat",
    members: [
      "Lenon Thompson", "Robert Woods", "Cornell Terrell",
      "Robert Spears", "Jarvis Seegars", "Timothy Williams",
      "Jeremy Odoffin", "Joshua Nelson", "Travis Sherman",
      "Kyle Smith",
    ],
  },
  {
    edition: "24th",
    name: "Sixteen Sentinels of a Surging Phoenix AKA Emperors of Enlightenment",
    members: [
      "Baker Blanding", "Christopher Caldwell", "Michael Harrison",
      "Roger Anthony", "Arondo Douglas", "Clifton McKnight",
      "Kellen Sims", "Jeremiah Perkins", "Therol Voche",
      "Stephon Gentry", "William Brown", "Nicholas Stewart",
      "Ricardo Johnson", "James Robinson", "Adelaja Thomas",
      "Edson Breedy",
    ],
  },
  {
    edition: "23rd",
    name: "26 Kings of the Emerging Sun AKA Nomadic Descendants of the Golden Shield",
    members: [
      "Clifton Lomax", "Jonathan \u201cKokayi\u201d Nichols",
      "William Little", "Justin Spears", "Marcus Ware",
      "The Spirit of Prince Carmen Jones Jr.", "Christopher Lewis",
      "Ronnell Wade", "John Siraj Horn", "Jeremy Phillips",
      "Richard Young", "Abimbola George", "Joshua Thomas",
      "Calvin Hadley", "Julius Prevost", "Alex Washington",
      "William J. Roberts", "Michael Wilson",
      "Dominic Blackwell Cooper", "Christopher Jackson",
      "Kenan Arnold", "Byron Branch", "Raasikh Muhammed",
      "AJ Collins", "Otto Stallworth", "Kemal Simpson",
    ],
  },
  {
    edition: "22nd",
    name: "20 Keepers of the Plague AKA Sons of the Seventh Day",
    members: [
      "Kofi Adease", "Michael Pigford II", "Edward Drew",
      "Anthony Woodburne Jr.", "David Johnson", "Dion Earl",
      "Gaspar David Stinfil", "Kevin Horton", "Kanaan Sammy",
      "Darius Lyles", "Faruq Hussein-Bey", "Remi Oguntoye",
      "David Chandler", "Marcus Lambert", "Tristan Mitchell",
      "Richard Turner", "Andrew Olaleye", "Jabari Smith",
      "Erin A. Ferguson", "Brandon Starling",
    ],
  },
  {
    edition: "21st",
    name: "22 Legends of Bedlam AKA Sons of the Golden Shield",
    members: [
      "Dominique Davis Jr.", "Shannon Veazey", "Andre Levy",
      "Terez Paylor", "Hari Williams",
      "Prince Carmen Jones Jr. (In Spirit)", "Sergio Marquez",
      "Jamel Willis", "Burley Marbrough", "David Harrison",
      "Jamar Dowdy", "Nick Giles", "Earl Fitzhugh", "Phillip Murray",
      "Taman Bradley", "Michael McGraw", "David Meares",
      "Norman Nick Walton", "Jason Johnson", "Ashford Thomas",
      "Shanell Lamar Patterson", "Wesley Ellis",
    ],
  },
  {
    edition: "20th",
    name: null,
    members: [
      "Sam Roberson", "Charles Bull", "Michael Williams",
      "Eric Holmes", "Timothy Anthony Chandler", "Aaron Davis",
      "Herbert Heatie", "Aaron Nelson", "Byron Hughes",
      "Ryan M. Seaforth", "Greg Wadsworth", "Conrad Woody",
      "Brandon Childs", "Justin Hilton Thomas", "Chris Barnes",
      "Daren Joseph", "Hillary Carrere", "Sean Parker",
      "Jermaine Small", "Montreal McMorris", "Zackery Wright",
      "Olan Williams",
    ],
  },
  {
    edition: "19th",
    name: "23 Eternal Princes of S.O.U.L.",
    members: [
      "Fred James Allen", "Gerard Clodomir", "Adam J. Jefferson",
      "Justin Brown", "Bert Dumas",
      "Prince Carmen Jones Jr. (In Spirit)", "Rahman L. Irvin",
      "Kaurian \u201cTut\u201d Butler-Edwards", "Leslie Broadway",
      "Isaiah Johnson", "William James Murphy", "George Purnell",
      "Raymond Pullium", "Jozen Pedro Cummings", "Shomari Small",
      "Cliff Davis", "Brian Stamps", "Harvey Maclin", "Ian Ward",
      "Jermain Roseman", "Jamin Powell", "Hakin Hasan",
      "William Brickers",
    ],
  },
  {
    edition: "18th",
    name: null,
    members: [
      "Thando Nongauza", "Brian Lawerence", "C. Antoine Brown",
      "Kelvin Mills",
    ],
  },
  {
    edition: "17th",
    name: null,
    members: [
      "Duvall (Trey) Miller III", "Ansel Collins", "Carleton Overstreet",
      "Narainsamy Butts", "David Peavy Jr.", "Tyrone Hurley Jr.",
      "Gemar D. Childress", "Derrick White", "William Marsh",
      "Jason T. Jackson", "Jordasche Oliver", "Brandon Garrett",
      "Johnie Earl McGee",
    ],
  },
  {
    edition: "16th",
    name: null,
    members: [],
  },
  {
    edition: "15th",
    name: null,
    members: [
      "Javier Benton", "Michael Pannell", "Morris Gordon", "Amein Carless",
      "Brandon White", "Michael Worthy", "James Brown", "Carlton Jordan",
      "Rafiq Abdus-Sabur", "Jahdal McKenzie", "Steven Walker",
      "Kevin Patterson",
    ],
  },
  {
    edition: "14th",
    name: null,
    members: [
      "Jabari Young", "Rueben Monmouth", "Hayward Tolbert",
      "Timothy Edwards", "Myyucca Sherman", "Yusef Snyder",
    ],
  },
  {
    edition: "13th",
    name: null,
    members: [
      "Papa Kobina Yankah", "Marcus Jones", "Kareem Jones",
      "Berkley Curtis", "Acklyn Murray", "Kirtracy Hill",
      "Dean Bruner", "Lakeem Dwight", "Lateef Martin",
      "Reggie Simmons", "Demetrius Kee", "Andrew Horge",
      "Eric Chancey", "William Monroe", "Drew Watkins",
    ],
  },
  {
    edition: "12th",
    name: null,
    members: [
      "Christopher French", "Charles Hill", "Kendall Brame",
      "Demetrius Jackson", "Danny Napper", "Mike Daniels",
      "Chris Tyson", "Russel Rickford", "Brandon Stiff",
      "Charles Heywood",
    ],
  },
  {
    edition: "11th",
    name: "The Six Sons of Endurance",
    members: [
      "Lindell Williams", "Trace Rutherford", "Martin Hammlette",
      "Dwight Gibson", "Carey Grady", "Prince Carmen Jones Jr.",
    ],
  },
  {
    edition: "10th",
    name: "The Talented Tenth",
    members: [
      "Shomari White", "Julian Celuther Gaither", "Derrick Rogers",
      "Jumain Jackson", "Eric Hearst", "Gregory J. Campbell",
      "Edward Rice III", "Erik Watson", "Bryan Jay Parker",
      "Shawn Andrew", "Edward Thomas", "Dwayne A. Bastiany",
    ],
  },
  {
    edition: "9th",
    name: null,
    members: [
      "Casey Badger", "Michael W. Boyer", "Leslloyd F. Alleyne",
      "Todd Bailey", "Joseph Gibbs", "Damon Wilson",
      "Michael A. Coleman Jr.", "C.D. Glin", "Vladimir Leveque",
      "Rodney Logan", "Oronde Miller", "Demetrius Garrett",
      "Jerel Jenkins", "Sean Allison",
    ],
  },
  {
    edition: "8th",
    name: null,
    members: [
      "Johnathan C. Augustine", "Thabani Banda",
      "Charvis Carter Campbell", "Christopher Coleman",
      "Wydell L. Croom", "DeWayne L. Davis", "Christopher Delaine",
      "Raymond Downs", "Solomon E. Eaddy", "Daniel S. Fenton",
      "D'Vell Garrison", "Steve Hamlette", "Jesse J. Henderson",
      "Mikel L. Husband (Deceased)", "Terrence A. Jones",
      "Robert L. Laurie", "Don H. May, Jr.", "Marcus E. McCuiston",
      "Brian D. Nevel", "Charles E. Quinn", "Jeffery C. Scott",
      "Jason C. Wan", "Andre' M. Webber",
    ],
  },
];

export const CONSTITUTION_URL =
  "https://customer-assets.emergentagent.com/job_gentlemen-collective/artifacts/mmidl4lg_GODSC_Constitution_2017.pdf";
